/* iSafe · aviso de estoque na pagina de produto
 *
 * O envio de verdade continua sendo o formulario de contato da Shopify: a loja
 * recebe o e-mail com nome, WhatsApp e produto. Este arquivo faz duas coisas
 * alem disso:
 *
 *   1. abre o painel de campos quando o visitante clica no botao;
 *   2. manda uma copia para o CRM, que e onde a lista de espera vive.
 *
 * Regra que vale para tudo aqui: NADA disto pode impedir o envio. Se o CRM
 * estiver fora do ar, o pedido do visitante ja esta indo por e-mail do mesmo
 * jeito. Por isso a copia sai por sendBeacon (ou fetch com keepalive) e
 * qualquer erro morre em silencio.
 *
 * O bloco e' reconstruido pelo tema a cada troca de variante
 * (product-info.js chama updateSourceFromDestination), entao os eventos ficam
 * no document, nunca no elemento.
 */
(function () {
  'use strict';

  var CHAVE_SESSAO = 'isafe_aviso_sessao';

  function sessao() {
    try {
      var s = localStorage.getItem(CHAVE_SESSAO);
      if (!s) {
        s = 'av-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        localStorage.setItem(CHAVE_SESSAO, s);
      }
      return s;
    } catch (e) {
      // navegacao anonima com armazenamento bloqueado: segue sem sessao
      return '';
    }
  }

  function bloco(alvo) {
    return alvo && alvo.closest ? alvo.closest('[data-isafe-aviso]') : null;
  }

  function valor(raiz, seletor) {
    var el = raiz.querySelector(seletor);
    return el && el.value ? el.value.trim() : '';
  }

  document.addEventListener('click', function (ev) {
    var abre = ev.target.closest && ev.target.closest('[data-av-abrir]');
    if (abre) {
      var raizA = bloco(abre);
      if (!raizA) return;
      var painel = raizA.querySelector('[data-av-painel]');
      if (!painel) return;
      painel.hidden = false;
      abre.hidden = true;
      abre.setAttribute('aria-expanded', 'true');
      var primeiro = painel.querySelector('input:not([hidden]):not([type=hidden])');
      if (primeiro) primeiro.focus();
      return;
    }

    var troca = ev.target.closest && ev.target.closest('[data-av-troca]');
    if (troca) {
      var raizT = bloco(troca);
      if (!raizT) return;
      var conta = raizT.querySelector('[data-av-conta]');
      var ident = raizT.querySelector('[data-av-identidade]');
      if (conta) conta.hidden = true;
      if (ident) {
        ident.hidden = false;
        // so agora os campos passam a ser obrigatorios: campo escondido e
        // obrigatorio trava o envio no navegador, sem mensagem util.
        ident.querySelectorAll('input').forEach(function (i) {
          i.required = true;
          i.setAttribute('aria-required', 'true');
        });
        var nome = ident.querySelector('input[type=text]');
        if (nome) { nome.value = ''; nome.focus(); }
        var email = ident.querySelector('input[type=email]');
        if (email) email.value = '';
      }
      raizT.dataset.logado = '0';
    }
  });

  document.addEventListener('submit', function (ev) {
    var raiz = ev.target && ev.target.closest ? ev.target.closest('[data-isafe-aviso]') : null;
    if (!raiz) return;

    var destino = (raiz.dataset.crm || '').trim();
    if (!destino) return; // CRM desligado no painel: segue so pelo e-mail

    var corpo = {
      sessao: sessao(),
      nome: valor(raiz, 'input[name="contact[name]"]'),
      whatsapp: valor(raiz, 'input[name="contact[WhatsApp]"]'),
      email: valor(raiz, 'input[name="contact[email]"]'),
      logado: raiz.dataset.logado === '1',
      cliente_shopify_id: raiz.dataset.clienteId || null,
      produto: {
        id: Number(raiz.dataset.produtoId) || null,
        titulo: raiz.dataset.produtoTitulo || '',
        url: raiz.dataset.produtoUrl || '',
        variante_id: Number(valor(raiz, 'input[name="contact[Variant ID]"]')) || null,
        variante_titulo: raiz.dataset.varianteTitulo || '',
        sku: raiz.dataset.sku || ''
      },
      origem: 'pagina-produto'
    };

    // O envio sai no exato momento em que a pagina comeca a sair do ar, porque o
    // formulario nativo navega. Dois cuidados por causa disso:
    //
    //   1. text/plain. Content-Type "application/json" nao esta na lista segura
    //      do CORS e obriga o navegador a mandar antes um OPTIONS de permissao.
    //      Esse pedido extra costuma nao terminar a tempo durante a navegacao, e
    //      o aviso se perde. text/plain dispensa o OPTIONS. O corpo continua
    //      sendo JSON: quem recebe so precisa aceitar esse tipo tambem.
    //   2. sendBeacon primeiro. E' a API feita para isto e sobrevive a saida da
    //      pagina. Onde nao existir, cai no fetch com keepalive.
    var texto = JSON.stringify(corpo);
    try {
      var mandou = false;
      if (navigator.sendBeacon) {
        mandou = navigator.sendBeacon(destino, new Blob([texto], { type: 'text/plain;charset=UTF-8' }));
      }
      if (!mandou) {
        fetch(destino, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: texto,
          keepalive: true,
          mode: 'cors'
        }).catch(function () {});
      }
    } catch (e) {
      // nunca atrapalhar o envio: o e-mail para a loja ja esta a caminho
    }
  });
})();
